import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import AddressSuggestion from "../AddressSuggestion";
import Preloader from "../Preloader";

import CustomSelect from "../CustomSelect";
import CustomDatepicker from "../Datepicker/CustomDatepicker";
import Modal from "../Modal";
import EditableInput from "./EditableInput";
import Autocomplete from "../Autocomplete";
import AutocompleteFirmValidation from "../AutocompleteFirmValidation";
import ContactsList from "./Contacts/ContactsList";
import WebsiteList from "./Websites/WebsitesList";
import CulturesList from "./Cultures/CulturesList";
import CroppedCultures from "./CroppedCultures";
import {formatDate, getFilials} from "../../helpers/core";
import TheBestOffersCalculator from "../../apiClient/TheBestOffersCalculator";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import OrdersList from "../SalesOrders/List/OrdersList";
import appConfig from "../../config/app";


class ClientForm extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const client = props.client;
    const historyStateClient = props.location.state
      ? props.location.state.client
      : null;
    let initialValues = {
      type: "",
      categories: "",
      cultures: [],
      contacts: [],
      filials: [],
      date_called: null,
      date_will_call: today,
      lat: "",
      lon: "",
      email: "",
      websites: [],
      vat: null,
      chosenVolume: null,
      chosenPrice: null,
    };

    if (historyStateClient) {
      initialValues = historyStateClient;
    } else if (client) {

      client.vat = transformNdsValueToOption(client.vat);
      initialValues = {
        ...initialValues,
        ...client,
        date_called: client.date_called,
        date_will_call: client.date_will_call,
        categories: client.categories
          ? client.categories.map(el => el.value)
          : [],
        type: props.type,
        id: client.id || null
      };
    }

    this.state = {
      values: initialValues,
      modals: {
        croppedHistory: false,
      },
      calcPriceErrors: [],
      croppedCultures: [],
      isSalesOrdersModalOpened: false,
      chosenSalesOrders: [],
      chosenCulture: null,
    };

    this.addedCultures = [];

    this.currentYear = today.getFullYear();

    this.rowData = {};
  }

  componentDidMount() {
/*
    this.props.client &&
      this.props.client.id &&
      this.props.updateTableOfChanging(this.props.client.id);
*/
  }

  handleError(errorMessage){
    toast.error(errorMessage);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.serverError) {
      this.handleError(nextProps.serverError);
    }
    const { priceUpdating } = this.props;
    const { cultures, croppedCultures } = this.state;
    if (
      nextProps.client &&
      nextProps.client.cultures !== cultures &&
      nextProps.priceUpdating !== priceUpdating &&
      priceUpdating
    ) {
      const cultures = nextProps.client.cultures.map(culture => {
        if (croppedCultures.indexOf(+culture.culture_id) !== -1) {
          culture.is_full_cropped = true;
        }
        return culture;
      });
      this.setState(prevState => ({
        values: {
          ...prevState.values,
          cultures: cultures.concat(this.addedCultures)
        }
      }));
    }
  }

  canTakeInWork() {
  	if (!this.props.showInWorkButton) {
  		return false;
    }
    let role = this.props.initData.role;
  	let isInWork = this.state.values.in_work;
  	if (isInWork) {
		return false;
	}
	if (role != 'sales') {
	  return false;
    }
	return true;
  }

  canCancelInWork() {
    if (!this.props.showCancelInWorkButton) {
		return false
  	}
  	let role = this.props.initData.role;
  	let userId = this.props.initData.user_id;
	let isInWork = this.state.values.in_work;
	let isInWorkBy = this.state.values.in_work_by;
	if (!isInWork) {
		return false;
	}
	if (role == 'sales')
	{
	  if (userId == isInWorkBy.id) {
	    return true;
      }
      return false;
	}
	if (role == 'headOfSales') {
	  return false;
    }
    return true;
  }

  canEdit() {
  	let role = this.props.initData.role;
  	let userId = this.props.initData.user_id;
	let isInWork = this.state.values.in_work;
	let isInWorkBy = this.state.values.in_work_by;
	if (role == 'admin' || role == 'headOfSales') {
		return true
	}
	if (!isInWork) {
		return true;
	}

	if (role == 'sales')
	{
	  if (userId == isInWorkBy.id) {
		  return true;
	  }
	}
	  return false;
  }

  onSubmit = e => {
    e.preventDefault();
    //При Нажитии Кнопки Обновить

    const { values } = this.state;

    const client = { ...values };
    this.props.onSubmit({
      client: { ...client }
    });

    //POST запрос на обновление таблицы изменений
    // this.props.client &&
    //   this.props.client.id &&
    //   this.props.updateTableOfChanging(client.id);
  };

  handleInputChange = (name, values) => {
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        [name]: values
      }
    }));
  };

  closeSalesOrdersModal = () => {
    this.setState(prevState => ({
      isSalesOrdersModalOpened: false,
      chosenSalesOrders: [],
      chosenCulture: null,
      values: {
        ...prevState.values,
        chosenVolume: null,
        chosenPrice: null,
      }
    }));
  }

  openSalesOrdersModal = (cultureId, price, volume) => {

    this.setState(prevState => ({
      isSalesOrdersModalOpened: true,
      chosenSalesOrders: this.props.getSalesOrdersByCulture(cultureId),
      chosenCulture: this.props
          .client
          .cultures
          .find(culture => culture.link_id === cultureId),
      values: {
        ...prevState.values,
        chosenVolume: volume.toString(),
        chosenPrice: price.toString(),
      }
    }));
  }

  handleCheckboxChange = e => {
    e.persist();
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        [e.target.name]: e.target.checked
      }
    }));
  };

  //Radio Button in Culture List
  handleCheckRadioButton = rowData => {
    this.rowData = rowData;
  };
  handleAddressAdd = ({ data }) => {
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        geo_id: data.geo_id,
        lat: data.geo_lat,
        lon: data.geo_lon,
        address: data.address
      }
    }));
  };

  handleFilialAdd = filial => {
    this.setState(prevState => {
      const list = prevState.values.filials;
      const index = list.indexOf(filial);
      if (index === -1) {
        list.push(filial);
      }

      return {
        values: {
          ...prevState.values,
          filials: list
        }
      };
    });
  };

  handleFilialRemove = id => {
    const index = this.state.values.filials.findIndex(
      filial => filial.id === id
    );
    if (index !== -1) {
      this.setState(prevState => {
        const list = prevState.values.filials;
        list.splice(index, 1);

        return {
          values: {
            ...prevState.values,
            filials: list
          }
        };
      });
    }
  };

  handleDateChange = (date, name) => {
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        [name]: date
      }
    }));
  };

  handleRemove = e => {
    e.preventDefault();
    this.props.onRemove();
  };

  getFilials = term => {
    return getFilials({ name: term });
  };

  cloneClient = e => {
    e.preventDefault();

    const data = this.state.values;
    delete data.id;

    this.props.history.replace({
      pathname: "/add",
      state: {
        client: data
      }
    });
  };

  openModal = e => {
    e.preventDefault();
    e.persist();

    this.setState(prevState => ({
      modals: {
        ...prevState.modals,
        [e.target.dataset.modal]: true
      }
    }));
  };

  hideModal = modal => {
    this.setState(prevState => ({
      modals: {
        ...prevState.modals,
        [modal]: false
      }
    }));
  };

  handleMoveCulture = (cultureId, toHistory) => {
    const {
      values: { cultures },
      croppedCultures,
      isCroppedHistoryModalOpened
    } = this.state;
    const index = cultures.findIndex(el => el.culture_id == cultureId);
    const croppedIndex = croppedCultures.indexOf(+cultureId);
    let isModalOpened = !!isCroppedHistoryModalOpened;
    if (index !== -1) {
      cultures[index].is_full_cropped = toHistory;
      cultures[index].year = toHistory ? this.currentYear : 0;
      if (toHistory) {
        croppedCultures.push(+cultureId);
      } else if (croppedIndex !== -1) {
        croppedCultures.splice(croppedIndex, 1);
        if (!croppedCultures.length) {
          isModalOpened = false;
        }
      }
    }

    this.setState(prevState => ({
      values: {
        ...prevState.values,
        cultures
      },
      croppedCultures,
      isCroppedHistoryModalOpened: isModalOpened
    }));
  };

  handleRemoveCulture = cultureId => {
    const {
      values: { cultures },
      croppedCultures,
      isCroppedHistoryModalOpened
    } = this.state;
    const index = cultures.findIndex(el => el.culture_id == cultureId);
    const croppedIndex = croppedCultures.indexOf(+cultureId);
    let isModalOpened = !!isCroppedHistoryModalOpened;
    if (croppedIndex !== -1) {
      croppedCultures.splice(croppedIndex, 1);
      if (!croppedCultures.length) {
        isModalOpened = false;
      }
    }

    if (index !== -1) {
      cultures.splice(index, 1);
    }

    this.setState(prevState => ({
      values: {
        ...prevState.values,
        cultures
      },
      croppedCultures,
      isCroppedHistoryModalOpened: isModalOpened
    }));
  };

  handleUpdateChildState = (list, key) => {
    const cultures = this.state.values.cultures;
    const croppedCultures = cultures.filter(el => el.is_full_cropped);
    const cb = () => {
      if (key === "cultures" && this.props.isEditMode) {
        const ids = this.props.client.cultures.map(c => c.culture_id);
        this.addedCultures = this.state.values.cultures.filter(
          c => ids.indexOf(c.culture_id) === -1
        );
      }
    };

    this.setState(
      prevState => ({
        values: {
          ...prevState.values,
          [key]: key === "cultures" ? list.concat(croppedCultures) : list
        }
      }),
      cb
    );
  };

  handleTodayClick = e => {
    e.preventDefault();
    this.handleDateChange(new Date(), "date_called");
  };

  calculateTheBestOffers = (grainId, transportCoefficeint, marginalProfit) => {
    let supplierId = this.state.values.id;

    return TheBestOffersCalculator.calculate(supplierId, grainId, transportCoefficeint, marginalProfit);
  };

  onInWork = e => {
	  e.preventDefault();
	  this.props.onInWork(this.state.values.id)
  };

  onCancelInWork = e => {
	  e.preventDefault();
	  this.props.onCancelInWork(this.state.values.id)
  };

  checkContainsActiveOrders(salesOrders)
  {
    if (!salesOrders) {
      return false;
    }

    return salesOrders.filter(
        salesOrder => salesOrder.isActive()
    ).length > 0
  }

  createSalesOrder = e => {
    e.preventDefault();

    this.props.createSalesOrder(
        this.state.values.id,
        parseInt(this.state.values.chosenPrice),
        this.state.chosenCulture.link_id,
        this.state.chosenCulture.culture_id,
        this.state.values.geo_id,
        this.state.values.chosenVolume,
        '' //Качество
    )
  }

  render() {
    const {
      initData,
      isEditMode,
      serverError,
      priceUpdating,
      clientSaving,
      showCalleeAsign,
      showDeleteAction,
      users,
      changes
    } = this.props;
    const { values, modals, calcPriceErrors } = this.state;
    const croppedCultures = values.cultures.filter(el => el.is_full_cropped);
    const culturesList = values.cultures.filter(el => !el.is_full_cropped);
    const maxNextCallDate = new Date();
    maxNextCallDate.setMonth(maxNextCallDate.getMonth() + 1);
    const isNew = !values.hasOwnProperty("id");
    const poleplanAdminEnterprisePageUrl = `${appConfig.poleplanAdminUrl}/profile/iframe/${this.state.values.id}?token=${appConfig.poleplanAdminAuthToken}`
    if (!initData) {
      return <Preloader />;
    }

    return (
      <div className="container">
        {priceUpdating || clientSaving ? <Preloader /> : null}
        <form className="custom-form">
          {serverError ? (
            <div className="alert alert-danger" role="alert">
              {serverError}
            </div>
          ) : null}
            { values.reachedLimit ? (
            <div className="alert alert-warning" role="alert">
                Достигнут лимит допустимых карточек "В работе".
            </div>
                ) : null }
          <div className="row">
            <div className="col-xs-2 custom-form__label">Название:</div>
            <div className="col-xs-10 client-title max">
              {isNew ? (
                <AutocompleteFirmValidation
                  getSuggestions={this.getFilials}
                  onSelect={selected =>
                    this.handleInputChange("name", selected.name)
                  }
                  onChange={value => this.handleInputChange("name", value)}
                  value={values.name}
                />
              ) : (
                <EditableInput
                  type="text"
                  value={values.name}
                  onChange={this.handleInputChange}
                  name="name"
                  editMode={!isEditMode}
				  redTitle={this.state.values.in_work}
                />
              )}
            </div>
          </div>

			{this.state.values.in_work ?
				<div className="row">
					<div className="col-xs-2 custom-form__label">В работе у:</div>
					<div className="col-xs-10">
						{this.state.values.in_work_by.fio}
					</div>
				</div> : <div></div>
			}

			{this.state.values.in_work ?
				<div className="row">
					<div className="col-xs-2 custom-form__label">Дата окончания статуса "В работе":</div>
					<div className="col-xs-10">
						{this.state.values.in_work_to}
					</div>
				</div> : <div></div>
			}

			<div className="row">
            <div className="col-xs-2 custom-form__label">
              Общая площадь, га:
            </div>
            <div className="col-xs-10">
              <div className="pull-left mr-right-20">
                <EditableInput
                  type="text"
                  value={values.area_full ? values.area_full.toString() : "0"}
                  onChange={this.handleInputChange}
                  name="area_full"
                  editMode={!isEditMode}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-4 custom-form__label with-select">
                Тип:
              </div>
              <div className="col-xs-5">
                <CustomSelect
                  name="type"
                  options={initData.client_type}
                  placeholder="Выберите тип"
                  values={values.type.toString()}
                  onSelect={this.handleInputChange}
                />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-4 custom-form__label with-select">
                Категория:
              </div>
              <div className="col-xs-6">
                <CustomSelect
                  name="categories"
                  options={initData.categories}
                  placeholder="Выберите категорию"
                  values={values.categories}
                  onSelect={this.handleInputChange}
                  multiple
                />
              </div>
            </div>
          </div>
          <div className="row">
            {isEditMode && values.creator ? (
              <div className="col-xs-6">
                <div className="col-xs-4 custom-form__label">Создана:</div>
                <div className="col-xs-8">
                  {values.creator.label} /{" "}
                  {initData.categories.find(
                    el => el.value == values.creator.value
                  )}
                </div>
              </div>
            ) : null}
            <div className="col-xs-6">
              <div className="col-xs-4 custom-form__label">Адрес:</div>
              <div className="col-xs-8">
                <input
                  type="text"
                  className="custom-form__input address-input"
                  value={values.address}
                  name="address"
                  disabled
                />
              </div>
            </div>
          </div>

          <ContactsList
            list={values.contacts}
            hideIsVisibleField={values.type.toString() !== '2'}
            isEditMode={isEditMode}
            showDeleteAction={showDeleteAction}
            updateState={this.handleUpdateChildState}
          />

          {calcPriceErrors.length ? (
            <div className="alert alert-danger mr-top-20">
              {calcPriceErrors.map((err, idx) => (
                <p key={idx}>{err}</p>
              ))}
            </div>
          ) : null}

          <CulturesList
            list={culturesList}
            isEditMode={isEditMode}
            showDeleteAction={true}
            cultures={initData.cultures}
            moveToCroppedList={this.handleMoveCulture}
            updateState={this.handleUpdateChildState}
            type={parseInt(values.type, 10)}
            radioSelected={this.handleCheckRadioButton}
            calculateTheBestOffers={this.calculateTheBestOffers}
            openSalesOrdersModal={this.openSalesOrdersModal}
            getSalesOrdersByCulture={this.props.getSalesOrdersByCulture}
          />

          {isEditMode && +values.type === 2 ? (
              <iframe
                  src={poleplanAdminEnterprisePageUrl}
                  style={{width: '102%', height: '720px'}}
              ></iframe>) : null
          }

          <div className="row">
            {croppedCultures.length && +values.type === 1 ? (
              <a
                href=""
                className="link"
                onClick={this.openModal}
                data-modal="croppedHistory"
              >
                История посевов
              </a>
            ) : null}
            <Modal
              onCloseClick={() => this.hideModal("croppedHistory")}
              isOpened={modals.croppedHistory}
            >
              <CroppedCultures
                list={croppedCultures}
                onRemove={this.handleRemoveCulture}
              />
            </Modal>
          </div>

          {isEditMode ? (
            <div className="row">
              <div className="col-xs-2 custom-form__label">Дата звонка:</div>
              <div className="col-xs-10">
                <div className="pull-left mr-right-20">
                  <CustomDatepicker
                    selectedDay={values.date_called}
                    name="date_called"
                    onDayChange={date =>
                      this.handleDateChange(date, "date_called")
                    }
                    disabledDays={[{ after: new Date() }]}
                  />
                </div>
                <div className="pull-left mr-right-20">
                  <a
                    href=""
                    title="Проставить сегодняшную дату звонка"
                    onClick={this.handleTodayClick}
                  >
                    Сегодня
                  </a>
                </div>
                {values.last_calls && values.last_calls.length ? (
                  <div className="col-xs-2 custom-form__label mr-right-40">
                    Исполнители:
                  </div>
                ) : null}
                {values.last_calls && values.last_calls.length ? (
                  <ul className="col-xs-5 callee-list">
                    {values.last_calls.map((call, key) => (
                      <li className="" key={`calee_${key}`}>
                        <span className="col-xs-8">{call.who}</span>
                        <span className="col-xs-4">
                          {formatDate(call.when)}
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </div>
          ) : null}

          <div className="row">
            <div className="col-xs-2 custom-form__label">Позвонить:</div>
            <div className="pull-left mr-right-20">
              <CustomDatepicker
                selectedDay={values.date_will_call}
                name="date_will_call"
                onDayChange={date =>
                  this.handleDateChange(date, "date_will_call")
                }
                disabledDays={[{ before: new Date(), after: maxNextCallDate }]}
              />
            </div>
            {showCalleeAsign && users.length ? (
              <div className="col-xs-3">
                <CustomSelect
                  name="will_callee_id"
                  options={users}
                  placeholder="Выберите исполнителя"
                  values={values.will_callee_id}
                  onSelect={this.handleInputChange}
                />
              </div>
            ) : null}
          </div>

          <div className="row">
            <div className="col-xs-2 custom-form__label">Тема звонка:</div>
            <div className="col-xs-5 max">
              <EditableInput
                type="text"
                value={values.call_aim}
                onChange={this.handleInputChange}
                name="call_aim"
                editMode={!isEditMode}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-2 custom-form__label">Дополнительно:</div>
            <div className="col-xs-5 max">
              <EditableInput
                type="text"
                value={values.additional_info}
                onChange={this.handleInputChange}
                name="additional_info"
                editMode={!isEditMode}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-2 custom-form__label">E-mail:</div>
            <div className="col-xs-3">
              <EditableInput
                type="email"
                value={values.email}
                onChange={this.handleInputChange}
                name="email"
                editMode={!isEditMode}
              />
            </div>
          </div>

          <WebsiteList
            list={values.websites}
            isEditMode={isEditMode}
            updateState={this.handleUpdateChildState}
          />

          {values.filials.length && +values.type !== 3 ? (
            <div className="row">
              <div className="col-xs-2 custom-form__label">Филиал:</div>
              <div className="col-xs-10">
                {values.filials.map((filial, key) => (
                  <p className="filial-item" key={key}>
                    {filial.name}
                    <span
                      className="filial-item__close"
                      onClick={this.handleFilialRemove.bind(this, filial.id)}
                    >
                      &times;
                    </span>
                  </p>
                ))}
              </div>
            </div>
          ) : null}

          {+values.type !== 3 ? (
            <div className="row">
              <div className="col-xs-2 custom-form__label">
                Добавить филиал:
              </div>
              <div className="col-xs-3">
                <Autocomplete
                  getSuggestions={this.getFilials}
                  onSelect={this.handleFilialAdd}
                />
              </div>
            </div>
          ) : null}

          <div className="row">
            <div className="col-xs-2 custom-form__label">
              НДС:
            </div>
            <CustomSelect
                name="vat"
                options={ndsOptions}
                placeholder="Выберите значение"
                values={values.vat}
                onSelect={this.handleInputChange}
            />
          </div>
          <div className="row">
            <div className="col-xs-2 custom-form__label">Договор:</div>
            <div className="col-xs-2">
              <input
                  type="checkbox"
                  name="contract"
                  checked={values.contract}
                  onChange={this.handleCheckboxChange}
              />
            </div>
          </div>

          {isEditMode ? (
          	this.canEdit() ?
            <div className="row action-buttons">
              <button
                className="btn btn-info col-xs-2 mr-right-20"
                onClick={this.onSubmit}
              >
                Обновить
              </button>
              <button
                className="btn btn-success col-xs-2 mr-right-20"
                onClick={this.cloneClient}
              >
                Копировать
              </button>
              {showDeleteAction ? (
                <button
                  className="btn btn-danger col-xs-2 mr-right-20"
                  onClick={this.handleRemove}
                >
                  Удалить
                </button>
              ) : null}
				{this.canTakeInWork() ? (
					<button
						className="btn btn-success col-xs-2 mr-right-20"
						onClick={this.onInWork}
					>
						В Работу
					</button>
				) : null}
				{this.canCancelInWork() ? (
					<button
						className="btn btn-danger col-xs-2 mr-right-20"
						onClick={this.onCancelInWork}
					>
						Отменить "В Работе"
					</button>
				) : null}
            </div> : null
          ) : (
            <div className="row action-buttons">
              {serverError ? (
                <p className="firm--exist">
                  Произошли ошибки в ходе сохранения
                </p>
              ) : null}
              <button
                className="btn btn-success col-xs-2 mr-right-20"
                onClick={this.onSubmit}
              >
                Сохранить
              </button>
            </div>
          )}
        </form>

        <div className="row">
          <div className="col-xs-6 mr-bottom-20">
            <AddressSuggestion
              query={values.address}
              placeholder="Введите адрес"
              onChange={this.handleAddressAdd}
            />
          </div>
        </div>
        {/*<h3>История изменений</h3>*/}
        {/*{changes && changes.length ? (*/}
        {/*  <TableOfChanging length={changes.length} changes={changes || []} />*/}
        {/*) : (*/}
        {/*  <span>Изменений не было</span>*/}
        {/*)}*/}

        {+values.type === 1 ? (
            <Modal isOpened={this.state.isSalesOrdersModalOpened} onCloseClick={this.closeSalesOrdersModal}>
              <div>
                <h3 className="text-center">Заявки на продажу {this.state.chosenCulture ? this.state.chosenCulture.name : null}</h3>
                <OrdersList
                    salesOrders={this.state.chosenSalesOrders}
                    cancelSalesOrder={this.props.cancelSalesOrder}
                />
                <div className="task-comment-form col-xs-12 mr-top-20">
                  <div className="row p-5">
                    <div className="col-xs-8">
                      <div className="col-xs-6 custom-form__label">Цена:</div>
                      <div className="col-xs-6">

                        <EditableInput
                            type="text"
                            value={this.state.values.chosenPrice}
                            onChange={this.handleInputChange}
                            name="chosenPrice"
                            editMode={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row p-5">
                    <div className="col-xs-8">
                      <div className="col-xs-6 custom-form__label">Объем:</div>
                      <div className="col-xs-6">
                        <EditableInput
                            type="text"
                            value={this.state.values.chosenVolume}
                            onChange={this.handleInputChange}
                            name="chosenVolume"
                            editMode={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row p-5">
                    <div className="clearfix">
                      <button
                          onClick={this.createSalesOrder}
                          className="btn btn-success pull-left mr-right-20"
                          disabled={this.checkContainsActiveOrders(this.state.chosenSalesOrders)}
                      >
                        Создать
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
        ) : null}

        <ToastContainer />
      </div>
    );
  }
}


const ndsOptions = [
  {
    value: 1,
    label: 'Нет информации',
  },
  {
    value: 2,
    label: 'С НДС',
  },
  {
    value: 3,
    label: 'Без НДС',
  },
];
const transformNdsValueToOption = (worksWithNds) =>
{
  switch (worksWithNds) {
    case null: return 1;
    case true: return 2;
    case false: return 3;
    default: return 1;
  }
}

ClientForm.propTypes = {
  location: PropTypes.object,
  isEditMode: PropTypes.bool,
  client: PropTypes.object,
  initData: PropTypes.object,
  onSubmit: PropTypes.func,
  type: PropTypes.number,
  history: PropTypes.object,
  serverError: PropTypes.string,
  showCalleeAsign: PropTypes.bool,
  showDeleteAction: PropTypes.bool,
  users: PropTypes.array,
  priceUpdating: PropTypes.bool,
  clientSaving: PropTypes.bool,
  onRemove: PropTypes.func,
  getSalesOrdersByCulture: PropTypes.func,
  createSalesOrder: PropTypes.func,
  cancelSalesOrder: PropTypes.func,
  salesOrders: PropTypes.array,
};

export default withRouter(ClientForm);



// WEBPACK FOOTER //
// ./components/ClientForm/index.js